import * as styles from "./ColorPickerSwatch.css";

import { clsx } from "clsx";
import type { JSX } from "react";

import { Icon } from "@frontend/components/atoms/Icon";

import type { ColorPickerSwatchProps } from "./ColorPicker.types";

export function ColorPickerSwatch({
  color,
  label,
  selected = false,
  active = false,
  shape = "circle",
  onSelect,
  className,
}: ColorPickerSwatchProps): JSX.Element {
  return (
    <button
      type="button"
      role="radio"
      aria-checked={selected}
      aria-label={label ?? color}
      title={label ?? color}
      tabIndex={active ? 0 : -1}
      data-slot="color-picker-swatch"
      data-selected={selected || undefined}
      className={clsx(styles.swatch({ shape }), className)}
      style={{ backgroundColor: color }}
      onClick={onSelect}
    >
      {selected && <Icon name="Check" size="sm" className={styles.check} />}
    </button>
  );
}
